export default {"src":"/_next/static/media/apply_onlineico.1cc41f31.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};